export const seoTextAccordion = () => {
  document.addEventListener("click", (event) => {
    const button = event.target.closest("#readMore");
    const content = document.querySelector(".seo-text__content");

    if (button && content) {
      if (content.classList.contains("expanded")) {
        content.style.maxHeight = "340px";
        button.textContent = wp.i18n.__('Read more', 'smartwood');
        content.classList.remove("expanded");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        button.textContent = wp.i18n.__('Reduce', 'smartwood');
        content.classList.add("expanded");
      }
    }
  });
};
